import { NavLink, useNavigate, Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";
import { useAuth } from "@/context/AuthContext";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { LayoutDashboard, Users, CalendarDays, Package, CreditCard, Settings, LogOut, Flame, Video, Dumbbell } from "lucide-react";

const TABS = [
  ["/admin", "admin.dashboard", LayoutDashboard],
  ["/admin/clients", "admin.clients", Users],
  ["/admin/classes", "admin.classes", CalendarDays],
  ["/admin/wod", "admin.wod", Flame],
  ["/admin/programs", null, Dumbbell, { es: "Coaching online", en: "Online coaching", fr: "Coaching en ligne" }],
  ["/admin/videos", null, Video, { es: "Videoteca", en: "Video library", fr: "Vidéothèque" }],
  ["/admin/products", "admin.products", Package],
  ["/admin/payments", "admin.payments", CreditCard],
  ["/admin/settings", "admin.settings", Settings],
];

export function AdminLayout({ children }) {
  const { t, tl } = useI18n();
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen bg-background">
      <aside className="fixed hidden h-full w-60 flex-col border-r border-border bg-card p-5 md:flex">
        <Link to="/admin" className="font-display text-lg font-bold tracking-tight">Frenchies Fitness &amp; Pilates</Link>
        <span className="mt-0.5 text-xs text-muted-foreground">{t("admin.title")}</span>
        <nav className="mt-8 flex flex-col gap-1">
          {TABS.map(([to, key, Icon, label]) => (
            <NavLink key={to} to={to} end={to === "/admin"} data-testid={`admin-nav-${to.split("/").pop()}`}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-primary text-primary-foreground" : "hover:bg-accent"}`}>
              <Icon className="h-5 w-5" /> {label ? tl(label) : t(key)}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto flex flex-col gap-2">
          <LanguageSwitcher />
          <button data-testid="admin-app-btn" onClick={() => navigate("/app")} className="rounded-xl px-4 py-2 text-left text-sm hover:bg-accent">{t("nav.dashboard")}</button>
          <button data-testid="admin-logout-btn" onClick={logout} className="flex items-center gap-2 rounded-xl px-4 py-2 text-left text-sm text-destructive hover:bg-accent"><LogOut className="h-4 w-4" /> {t("nav.logout")}</button>
        </div>
      </aside>

      {/* mobile top nav */}
      <div className="w-full md:pl-60">
        <div className="glass sticky top-0 z-30 flex items-center gap-3 overflow-x-auto border-b border-border px-4 py-3 no-scrollbar md:hidden">
          {TABS.map(([to, key, Icon, label]) => (
            <NavLink key={to} to={to} end={to === "/admin"} className={({ isActive }) => `flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium ${isActive ? "bg-primary text-primary-foreground" : "bg-secondary"}`}>
              <Icon className="h-4 w-4" /> {label ? tl(label) : t(key)}
            </NavLink>
          ))}
        </div>
        <main className="p-5 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
